export default __webpack_public_path__ + "static/media/info_black_24dp.a012f8b1.svg";